<ng-container [ngSwitch]="error">
  <!-- PLACE -->
  <ng-container *ngSwitchCase="'E_CANNOT_DELETE_PLACE_WITH_MOVEMENTS_IN_PROGRESS_ON_STOCK'">
    {{ 'FUNCTIONNAL_ERRORS.PLACEWITHSTOCK' | translate }}
  </ng-container>
  <!-- PARTNERSHIP -->
  <ng-container *ngSwitchCase="'E_NO_PARTNER_FOUND_FOR_CODE'">
    {{ 'FUNCTIONNAL_ERRORS.E_NO_PARTNER_FOUND_FOR_CODE' | translate }}
  </ng-container>
  <!-- STOCK -->
  <ng-container *ngSwitchCase="'stock.update.withOperation'">
    {{ 'FUNCTIONNAL_ERRORS.STOCKUPDATEWITHOPERATION' | translate }}
  </ng-container>
  <ng-container *ngSwitchCase="'stock.update.ticket'">
    {{ 'FUNCTIONNAL_ERRORS.STOCKUPDATETICKET' | translate }}
  </ng-container>
  <ng-container *ngSwitchCase="'stock.aggregate.ticket'">
    {{ 'FUNCTIONNAL_ERRORS.STOCKAGGREGATETICKET' | translate }}
  </ng-container>
  <ng-container *ngSwitchCase="'stock.delete.withOperation'">
    {{ 'FUNCTIONNAL_ERRORS.STOCKDELETEWITHOPERATION' | translate }}
  </ng-container>
  <ng-container *ngSwitchCase="'stock.usedTicket'">
    {{ 'FUNCTIONNAL_ERRORS.STOCKUSETICKETS' | translate }}
  </ng-container>
  <ng-container *ngSwitchCase="'stock.declareBreak.quantity'">
    {{ 'FUNCTIONNAL_ERRORS.STOCKDECLAREBREAKQUANTITY' | translate }}
  </ng-container>
  <ng-container *ngSwitchCase="'stock.update.notOwnerPlace'">
    {{ 'FUNCTIONNAL_ERRORS.STOCKUPDATEPLACENOTOWNER' | translate }}
  </ng-container>
  <ng-container *ngSwitchCase="'stock.empty.ids'">
    {{ 'FUNCTIONNAL_ERRORS.STOCKEMPTYIDS' | translate }}
  </ng-container>
  <ng-container *ngSwitchCase="'stock.ticket.not.compliant'">
    {{ 'FUNCTIONNAL_ERRORS.STOCKTICKETNOTCOMPLIANT' | translate }}
  </ng-container>
  <ng-container *ngSwitchCase="'stock.like.not.found'">
    {{ 'FUNCTIONNAL_ERRORS.STOCKLIKENOTFOUND' | translate }}
  </ng-container>
  <ng-container *ngSwitchCase="'stock.theft.ticket'">
    {{ 'FUNCTIONNAL_ERRORS.STOCKTHEFTTICKET' | translate }}
  </ng-container>
  <ng-container *ngSwitchCase="'stock.ticket.duplicate.unauthorized'">
    {{ 'FUNCTIONNAL_ERRORS.STOCKTICKETDUPLICATEUNAUTHORIZED' | translate }}
  </ng-container>
  <ng-container *ngSwitchCase="'stock.update.state.broken'">
    {{ 'FUNCTIONNAL_ERRORS.STOCKUPDATESTATEBROKEN' | translate }}
  </ng-container>
  <ng-container *ngSwitchCase="'stock.move.bad.state'">
    {{ 'FUNCTIONNAL_ERRORS.STOCKMOVEBADSTATE' | translate }}
  </ng-container>
  <ng-container *ngSwitchCase="'stock.move.bad.quantity'">
    {{ 'FUNCTIONNAL_ERRORS.STOCKMOVEBADQUANTITY' | translate }}
  </ng-container>
  <ng-container *ngSwitchCase="'stock.quality.not.allowed'">
    {{
      'FUNCTIONNAL_ERRORS.STOCKQUALITYNOTALLOWED' | translate:{
        quality: getSupportQuality(variable[0]), support: getSupport(variable[1])
      }
    }}
  </ng-container>
  <ng-container *ngSwitchCase="'stock.support.not.tradeable'">
    {{ 'FUNCTIONNAL_ERRORS.STOCKSUPPORTNOTTRADEABLE' | translate:{support: getSupport(variable[0])} }}
  </ng-container>
  <ng-container *ngSwitchCase="'E_STOCK_ALREADY_EXISTS'">
    {{ 'FUNCTIONNAL_ERRORS.E_STOCK_ALREADY_EXISTS' | translate }}
  </ng-container>
  <!-- OPERATION -->
  <ng-container *ngSwitchCase="'operation.outMov.stock.notFound'">
    {{ 'FUNCTIONNAL_ERRORS.OPERATIONOUTMOVSTOCKNOTFOUND' | translate }}
  </ng-container>
  <ng-container *ngSwitchCase="'operation.outMov.stock.quantity'">
    {{ 'FUNCTIONNAL_ERRORS.OPERATIONOUTMOVSTOCKQUANTITY' | translate }}
  </ng-container>
  <ng-container *ngSwitchCase="'operation.duplication.place.notFound'">
    {{ 'FUNCTIONNAL_ERRORS.OPERATIONDUPLICATEPLACENOTFOUND' | translate }}
  </ng-container>
  <ng-container *ngSwitchCase="'operation.mov.inProgress.stock'">
    {{ 'FUNCTIONNAL_ERRORS.MOVEMENTONSTOCKINPROGRESSSTATE' | translate }}
  </ng-container>
  <ng-container *ngSwitchCase="'operation.alreadyAccepted'">
    {{ 'FUNCTIONNAL_ERRORS.MOVEMENTALREADYACCEPTED' | translate }}
  </ng-container>
  <ng-container *ngSwitchCase="'contestation.alreadyExists'">
    {{ 'FUNCTIONNAL_ERRORS.CONTESTATIONALREADYEXISTS' | translate }}
  </ng-container>
  <ng-container *ngSwitchCase="'operation.collaborative.unauthorized'">
    {{ 'FUNCTIONNAL_ERRORS.OPERATIONCOLLABORATIVEUNAUTHORIZED' | translate }}
  </ng-container>
  <ng-container *ngSwitchCase="'operation.collaborative.movement.ticket'">
    {{ 'FUNCTIONNAL_ERRORS.OPERATIONCOLLABORATIVEMOVEMENTTICKET' | translate }}
  </ng-container>
  <ng-container *ngSwitchCase="'operation.collaborative.exist.balance'">
    {{ 'FUNCTIONNAL_ERRORS.OPERATIONCOLLABORATIVEEXISTBALANCE' | translate }}
  </ng-container>
  <ng-container *ngSwitchCase="'operation.company.cant.contest'">
    {{ 'FUNCTIONNAL_ERRORS.OPERATIONCOMPANYCANTCONTEST' | translate }}
  </ng-container>
  <ng-container *ngSwitchCase="'operation.not.duplicable'">
    {{ 'FUNCTIONNAL_ERRORS.OPERATIONNOTDUPLICABLE' | translate }}
  </ng-container>
  <ng-container *ngSwitchCase="'operation.not.acceptable'">
    {{ 'FUNCTIONNAL_ERRORS.OPERATIONNOTACCEPTABLE' | translate }}
  </ng-container>
  <ng-container *ngSwitchCase="'operation.not.cancelable'">
    {{ 'FUNCTIONNAL_ERRORS.OPERATIONNOTCANCELABLE' | translate }}
  </ng-container>
  <ng-container *ngSwitchCase="'operation.not.refusable'">
    {{ 'FUNCTIONNAL_ERRORS.OPERATIONNOTREFUSABLE' | translate }}
  </ng-container>

  <!-- SHIPMENT -->
  <ng-container *ngSwitchCase="'E_INITIATOR_MUST_HAVE_PARTNERSHIPS_WITH_COMPANY'">
    {{ 'FUNCTIONNAL_ERRORS.E_INITIATOR_MUST_HAVE_PARTNERSHIPS_WITH_COMPANY' | translate }}
  </ng-container>
  <ng-container *ngSwitchCase="'E_INITIATOR_DOES_NOT_HAVE_PRIVILEGE_TO_CREATE_SHIPMENT'">
    {{ 'FUNCTIONNAL_ERRORS.E_INITIATOR_DOES_NOT_HAVE_PRIVILEGE_TO_CREATE_SHIPMENT' | translate }}
  </ng-container>
  <ng-container *ngSwitchCase="'E_SUPPORT_NOT_FOUND_FOR_NAME'">
    {{ 'FUNCTIONNAL_ERRORS.E_SUPPORT_NOT_FOUND_FOR_NAME' | translate }}
  </ng-container>
  <ng-container *ngSwitchCase="'E_SUPPORT_QUALITY_NOT_FOUND_FOR_NAME'">
    {{ 'FUNCTIONNAL_ERRORS.E_SUPPORT_QUALITY_NOT_FOUND_FOR_NAME' | translate }}
  </ng-container>
  <ng-container *ngSwitchCase="'E_SENDER_PLACE_NOT_FOUND_FOR_COMPANY'">
    {{ 'FUNCTIONNAL_ERRORS.E_SENDER_PLACE_NOT_FOUND_FOR_COMPANY' | translate }}
  </ng-container>
  <ng-container *ngSwitchCase="'E_RECEIVER_PLACE_NOT_FOUND_FOR_COMPANY'">
    {{ 'FUNCTIONNAL_ERRORS.E_RECEIVER_PLACE_NOT_FOUND_FOR_COMPANY' | translate }}
  </ng-container>
  <ng-container *ngSwitchCase="'E_CARRIER_PLACE_NOT_FOUND_FOR_COMPANY'">
    {{ 'FUNCTIONNAL_ERRORS.E_CARRIER_PLACE_NOT_FOUND_FOR_COMPANY' | translate }}
  </ng-container>
  <ng-container *ngSwitchCase="'E_INITIATOR_SHOULD_BE_ONE_OF_THE_ACTORS'">
    {{ 'FUNCTIONNAL_ERRORS.E_INITIATOR_SHOULD_BE_ONE_OF_THE_ACTORS' | translate }}
  </ng-container>
  <ng-container *ngSwitchCase="'E_SENDER_PLACE_AND_RECEIVER_PLACE_CANNOT_BE_IDENTICAL'">
    {{ 'FUNCTIONNAL_ERRORS.E_SENDER_PLACE_AND_RECEIVER_PLACE_CANNOT_BE_IDENTICAL' | translate }}
  </ng-container>
  <ng-container *ngSwitchCase="'E_DECLARATIVE_SENDER_AND_DECLARATIVE_RECEIVER_CANNOT_BE_IDENTICAL'">
    {{ 'FUNCTIONNAL_ERRORS.E_DECLARATIVE_SENDER_AND_DECLARATIVE_RECEIVER_CANNOT_BE_IDENTICAL' | translate }}
  </ng-container>
  <ng-container *ngSwitchCase="'E_CARRIER_CANNOT_BE_SENDER_OR_RECEIVER'">
    {{ 'FUNCTIONNAL_ERRORS.E_CARRIER_CANNOT_BE_SENDER_OR_RECEIVER' | translate }}
  </ng-container>
  <ng-container *ngSwitchCase="'E_SENDER_CANNOT_SEND_SHIPMENT_WITH_BROKEN_QUANTITY'">
    {{ 'FUNCTIONNAL_ERRORS.E_SENDER_CANNOT_SEND_SHIPMENT_WITH_BROKEN_QUANTITY' | translate }}
  </ng-container>
  <ng-container *ngSwitchCase="'E_INITIATOR_CANNOT_HAVE_A_BALANCE_WITH_HIMSELF'">
    {{ 'FUNCTIONNAL_ERRORS.E_INITIATOR_CANNOT_HAVE_A_BALANCE_WITH_HIMSELF' | translate }}
  </ng-container>
  <ng-container *ngSwitchCase="'E_INITIATOR_HAS_NOT_ENOUGH_WRITE_PRIVILEGES'">
    {{ 'FUNCTIONNAL_ERRORS.E_INITIATOR_HAS_NOT_ENOUGH_WRITE_PRIVILEGES' | translate }}
  </ng-container>
  <ng-container *ngSwitchCase="'E_SHIPMENT_SHOULD_BE_IN_TRIPART_MODE_TO_RETRIEVE_PARTNER_ACTORS_OF_THE_COMPANY'">
    {{ 'FUNCTIONNAL_ERRORS.E_SHIPMENT_SHOULD_BE_IN_TRIPART_MODE_TO_RETRIEVE_PARTNER_ACTORS_OF_THE_COMPANY' | translate }}
  </ng-container>
  <ng-container *ngSwitchCase="'E_RELOCATION_REFERENCE_MUST_BE_SET_TO_RELOCATION_SHIPMENT_ONLY'">
    {{ 'FUNCTIONNAL_ERRORS.E_RELOCATION_REFERENCE_MUST_BE_SET_TO_RELOCATION_SHIPMENT_ONLY' | translate }}
  </ng-container>

  <!-- IMPORT -->
  <ng-container *ngSwitchCase="'import.file.not.enough.movement'">
    {{ 'FUNCTIONNAL_ERRORS.IMPORTFILENOTENOUGHMOVEMENT' | translate }}
  </ng-container>
  <ng-container *ngSwitchCase="'import.file.version.not.supported'">
    {{ 'FUNCTIONNAL_ERRORS.IMPORTFILEVERSIONNOTSUPPORTED' | translate }}
  </ng-container>
  <ng-container *ngSwitchCase="'import.file.is.not.excel'">
    {{ 'FUNCTIONNAL_ERRORS.IMPORTFILEISNOTEXCEL' | translate }}
  </ng-container>
  <ng-container *ngSwitchCase="'import.file.is.group.import.type'">
    {{ 'FUNCTIONNAL_ERRORS.IMPORTFILEISGROUPIMPORTTYPE' | translate }}
  </ng-container>

  <!-- SEARCH -->
  <ng-container *ngSwitchCase="'search.empyLocation'">
    {{ 'FUNCTIONNAL_ERRORS.SEARCHEMPTYLOCATION' | translate }}
  </ng-container>
  <!-- WITH VARIABLE -->
  <!-- OPERATION -->
  <ng-container *ngSwitchCase="'operation.stock.notEnoughtQuantity'">
    <ng-container *ngIf="variable.length >= 1">
      {{ 'FUNCTIONNAL_ERRORS.OPERATIONDUPLICATESTOCKENOUGHTQUANTITY' | translate:{quantity: variable[1]} }}
    </ng-container>
  </ng-container>
  <ng-container *ngSwitchCase="'operation.history.comment.mandatory'">
    {{ 'FUNCTIONNAL_ERRORS.MANDATORYMESSAGE' | translate }}
  </ng-container>
  <ng-container *ngSwitchCase="'operation.notFound'">
    {{ 'FUNCTIONNAL_ERRORS.OPERATIONNOTFOUND' | translate }}
  </ng-container>
  <ng-container *ngSwitchCase="'operation.not.inprogress'">
    {{ 'FUNCTIONNAL_ERRORS.OPERATIONNOTINPROGRESS' | translate }}
  </ng-container>
  <ng-container *ngSwitchCase="'operation.confirm.not.acceptedorConfirmed'">
    {{ 'FUNCTIONNAL_ERRORS.OPERATIONCONFIRMNOTACCEPTEDORCONFIRMED' | translate }}
  </ng-container>
  <ng-container *ngSwitchCase="'operation.confirm.mismatch.type'">
    {{ 'FUNCTIONNAL_ERRORS.OPERATIONCONFIRMMISMATCHTYPE' | translate:{operationType: variable[1]} }}
  </ng-container>
  <ng-container *ngSwitchCase="'operation.confirm.date.before'">
    {{ 'FUNCTIONNAL_ERRORS.OPERATIONCONFIRMDATEBEFORE' | translate:{date: variable[0]} }}
  </ng-container>
  <ng-container *ngSwitchCase="'operation.confirm.unauthorized'">
    {{ 'FUNCTIONNAL_ERRORS.OPERATIONCONFIRMUNAUTHORIZED' | translate }}
  </ng-container>
  <ng-container *ngSwitchCase="'operation.outMov.stock.quantity.altered'">
    {{ 'FUNCTIONNAL_ERRORS.OPERATIONOUTMOVSTOCKQUANTITYALTERED' | translate }}
  </ng-container>
  <ng-container *ngSwitchCase="'contestation.invalid.date'">
    {{ 'FUNCTIONNAL_ERRORS.CONTESTATIONINVALIDDATE' | translate }}
  </ng-container>
  <!-- PROFIL -->
  <ng-container *ngSwitchCase="'user.deletion.oneself'">
    {{ 'FUNCTIONNAL_ERRORS.USERDELETIONONESELF' | translate }}
  </ng-container>
  <ng-container *ngSwitchCase="'user.deletion.administratorGroup'">
    {{ 'FUNCTIONNAL_ERRORS.USERDELETIONADMINISTRATORGROUP' | translate }}
  </ng-container>
  <ng-container *ngSwitchCase="'user.deletion.last.admin'">
    {{ 'FUNCTIONNAL_ERRORS.USERDELETIONLASTADMIN' | translate }}
  </ng-container>
  <ng-container *ngSwitchCase="'user.deletion.isAdmin'">
    {{ 'FUNCTIONNAL_ERRORS.USERDELETIONISADMIN' | translate }}
  </ng-container>
  <ng-container *ngSwitchCase="'user.alreadyInCompany'">
    {{ 'FUNCTIONNAL_ERRORS.USERALREADYINCOMPANY' | translate }}
  </ng-container>
  <ng-container *ngSwitchCase="'user.notAllowed'">
    {{ 'FUNCTIONNAL_ERRORS.USERNOTALLOWED' | translate }}
  </ng-container>
  <ng-container *ngSwitchCase="'user.alreadyExists'">
    {{ 'FUNCTIONNAL_ERRORS.USERALREADYEXISTS' | translate }}
  </ng-container>
  <ng-container *ngSwitchCase="'user.cannotBeCreated'">
    {{ 'FUNCTIONNAL_ERRORS.USERCANNOTBECREATED' | translate }}
  </ng-container>
  <ng-container *ngSwitchCase="'user.update.notAllowed'">
    {{ 'FUNCTIONNAL_ERRORS.USERUPDATENOTALLOWED' | translate }}
  </ng-container>
  <ng-container *ngSwitchCase="'user.link.expired'">
    {{ 'FUNCTIONNAL_ERRORS.USERLINKEXPIRED' | translate }}
  </ng-container>
  <ng-container *ngSwitchCase="'user.link.error'">
    {{ 'FUNCTIONNAL_ERRORS.USERLINKERROR' | translate }}
  </ng-container>
  <ng-container *ngSwitchCase="'user.mail.notFound'">
    {{ 'FUNCTIONNAL_ERRORS.USERMAILNOTFOUND' | translate }}
  </ng-container>
  <!-- PARTNER -->
  <ng-container *ngSwitchCase="'company.code.notExists'">
    {{ 'FUNCTIONNAL_ERRORS.COMPANYCODENOTEXISTS' | translate }}
  </ng-container>
  <ng-container *ngSwitchCase="'partnership.alreadyExists'">
    {{ 'FUNCTIONNAL_ERRORS.PARTNERSHIPALREADYEXISTS' | translate }}
  </ng-container>
  <ng-container *ngSwitchCase="'partnership.notVerified'">
    {{ 'FUNCTIONNAL_ERRORS.PARTNERSHIPNOTVERIFIED' | translate }}
  </ng-container>
  <ng-container *ngSwitchCase="'partnership.verified'">{{ 'FUNCTIONNAL_ERRORS.PARTNERSHIPVERIFIED' | translate }}
  </ng-container>

  <!-- DEFAULT -->
  <ng-container *ngSwitchDefault>{{ 'FUNCTIONNAL_ERRORS.DEFAULT' | translate }}</ng-container>
</ng-container>
